/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import RichTextField from '@components/molecules/RichTextField';
import MediaField from '@organisms/MediaField';
import { Button, Checkbox } from '@atoms';
import { TextField } from '@molecules';

import Form from '../Form';

import { TABBED_ITEM_FIELDS } from './constant';

const SectionForm = ({ onSubmit, initialValues: initData, buttons, className, initKey }) => {
  const [form] = Form.useForm(TABBED_ITEM_FIELDS);

  const handleSetLive = React.useCallback(
    (e) => form.setFieldsValue({ [TABBED_ITEM_FIELDS.TAB_VISIBILITY.name]: e.target.checked }),
    [form],
  );

  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  return (
    <Form
      onSerializedFinish={handleFinish}
      initialValues={initialValues}
      className={className}
      layout="vertical"
      labelAlign="left"
      colon={false}
      form={form}
    >
      {buttons && <Typography.Text level={3}>Edit Section</Typography.Text>}
      <Row>
        <Col flex="1">
          <Row>
            <Col flex="1">
              <Form.Item valuePropName="checked" {...TABBED_ITEM_FIELDS.TAB_VISIBILITY}>
                <Checkbox onChange={handleSetLive}>Show this section</Checkbox>
              </Form.Item>
              <TextField {...TABBED_ITEM_FIELDS.TAB_TITLE} />
              <MediaField {...TABBED_ITEM_FIELDS.TAB_IMAGE} />
              <RichTextField
                {...TABBED_ITEM_FIELDS.TAB_DESCRIPTION}
                initKey={`${TABBED_ITEM_FIELDS.TAB_DESCRIPTION.name}-${initKey}`}
              />
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD SECTION
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default SectionForm;
